import React, { useEffect, useState, } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Box from '@material-ui/core/Box';
import { AffirmationWithCategory } from '../../../../interfaces/tell_me/affirmationWithCategory.types';
import { deleteAffirmations, getAllCategories } from '../../../../api/api';
import { Category } from '../../../../interfaces/tell_me/category.types';
import { IconButton, ListItem } from '@material-ui/core';
import { Delete as DeleteIcon } from '@material-ui/icons';
import { useDispatch,useSelector } from 'react-redux';
import { getDataSetToRedux } from '../../../../utility/getAffirmationAndCategory';
import { AppState } from '../../../../store/store';

interface Props {
    handleClose: VoidFunction,
    affirmation: AffirmationWithCategory,
    open: boolean,
}

export default function DeleteAffirmationDialog(props: Props) {

    const dispatch = useDispatch();
    const allCategories = useSelector((state: AppState) => state.categories);
    const [categories, setCategories] = useState<Array<string>>(props.affirmation.categoryIds)

    // set Categories
    useEffect(() => {
        console.log("use Effected");
        setCategories(props.affirmation.categoryIds);
    }, [props.affirmation, props.open])

    const handleDelete = async (affirmation: AffirmationWithCategory, categoryIdToDelete: string) => {

        const _categories = [...categories];
        let deleteIndex = -1;
        for (let i = 0; i < _categories.length; i++) {
            if (categoryIdToDelete === _categories[i]) {
                deleteIndex = i;
            }
        }

        console.log(deleteIndex);
        if (deleteIndex !== -1) {
            console.log("DELETED");
            const response = await deleteAffirmations(affirmation.id, [categoryIdToDelete]);
            await getDataSetToRedux(dispatch);

            props.handleClose();
            if (response.success) {
                _categories.splice(deleteIndex, 1);
                setCategories(_categories);
                alert("Deleted");
            } else {
                console.log(response);
                alert("Error");
            }
        }else{
            alert("Error Finding The Category!");
        }
    }

    const findCategoryNameById= (categoryId: string):string => {
        const category = allCategories.find(category => category.id === categoryId);
        if (category) {
            return category.name;
        }
        return "ERROR!";
    }


    // Handle Close Dialog
    const handleClose = () => {
        props.handleClose();
    }

    return (
        <Dialog open={props.open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Delete Affirmation</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    You may delete affirmations from a number of categories
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    label="text"
                    type="email"
                    fullWidth
                    value={props.affirmation.text}
                />
                <Box height={15} />

                {categories.map((categoryId) => {

                    return (
                        <ListItem id={categoryId}>
                            <IconButton onClick={() => handleDelete(props.affirmation, categoryId)}>
                                <DeleteIcon />
                            </IconButton>
                            {findCategoryNameById(categoryId)}
                        </ListItem>

                    )
                })}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}


